export default class LicenceExperience {
    prix = 0;
    receivePromo = 0;
    sendInvoice = 1;
    health_form = {};
    id_course = null;
    type_licence_experience = "";
    confirmed = false;

    set(data) {
        if (!data) return;
        this.prix = data.prix != null ? parseFloat(data.prix) : 0;
        this.receivePromo = data.receivePromo == 1 || data.receivePromo === true ? 1 : 0;
        this.sendInvoice = data.sendInvoice == 0 || data.sendInvoice === false ? 0 : 1;
        this.health_form = data.health_form || {};
        this.id_course = data.id_course != null ? data.id_course : null;
        this.type_licence_experience = data.type_licence_experience || "";
        this.confirmed = data.confirmed === true || data.confirmed === 1 || data.confirmed === "1";
    }

    toPayload() {
        return {
            prix: this.prix,
            receivePromo: this.receivePromo,
            sendInvoice: this.sendInvoice,
            health_form: this.health_form,
            id_course: this.id_course,
            type_licence_experience: this.type_licence_experience,
            confirmed: this.confirmed,
        };
    }
}
